import { gql } from 'graphql-request';

export const WATCH_LIST = gql`
  query ($country: String, $translation: String) {
    watchList(country: $country, translation: $translation) {
      id
      title
      contents {
        ... on Movie {
          id
          title
          originalTitle
          businessType
          assetType
          assetSubType
          releaseDate
          contentPartner {
            id
            name
            image {
              rectangleDarkLogo
              rectangleWhiteLogo
              circleDarkLogo
              circleWhiteLogo
            }
            deeplinkUrl
          }
          overlayImageRectangleWhite {
            list
            cover
            listClean
            sticker
            svodCover
            appCover
            channelSquare
            channelList
            square
            portrait
            logo
            verticalBanner
            mobileBanner
            desktopBanner
            banner4k
          }
          image {
            list
            cover
          }
        }
        ... on TVShow {
          id
          title
          originalTitle
          businessType
          episodes {
            id
            title
            originalTitle
            businessType
            assetType
            assetSubType
            releaseDate
            image {
              list
              cover
            }
            tags
            episodeNumber
            billingType
            slug
            webUrl
            contentPartner {
              id
              name
              image {
                rectangleDarkLogo
                rectangleWhiteLogo
                circleDarkLogo
                circleWhiteLogo
              }
              deeplinkUrl
            }
            overlayImageRectangleWhite {
              list
              cover
              listClean
              sticker
              svodCover
              appCover
              channelSquare
              channelList
              square
              portrait
              logo
              verticalBanner
              mobileBanner
              desktopBanner
              banner4k
            }
          }
          assetType
          assetSubType
          releaseDate
          image {
            list
            cover
          }
        }
      }
    }
  }
`;

export const ADD_TO_WATCH_LIST = gql`
  mutation ($input: WatchListInput!) {
    addToWatchList(input: $input) {
      status
      code
      message
    }
  }
`;

export const DELETE_FROM_WATCHLIST = gql`
  mutation DFW($id: String!, $assetType: Int!) {
    deleteFromWatchList(id: $id, assetType: $assetType) {
      status
      code
      message
    }
  }
`;
